export interface WheelField {
    id: string;
    value: WheelValue;
};

export enum WheelValue {
    ONE = 1,
    TWO = 2,
    THREE = 3,
    FOUR = 4,
    FIVE = 5,
    SIX = 6,
    SEVEN = 7,
    EIGHT = 8,
    NINE = 9,
    TEN = 10,
    FIFTEEN = 15
}